module.exports = __webpack_public_path__ + "img/experts.ad11493f.svg";